var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trustpilot", class: { experiment: _vm.isExperiment } },
    [
      _c("h2", { staticClass: "header" }, [_vm._v("Trustpilot score")]),
      _vm._v(" "),
      _c("p", [_vm._v("Independent consumer rating")]),
      _vm._v(" "),
      _vm._m(0)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rating" }, [
      _c("data", { attrs: { value: "4.7" } }, [_vm._v("4.7")]),
      _vm._v(" "),
      _c("span", {
        staticClass: "b-sprite-paywall-trustpilot-stars trustpilot-stars"
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }